import { useCustomReducer } from '../../../../../base/customHooks'
import IPButton from '../../../../../components/IPButton'
import { useEffect, useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { exportToXLSX, exportToXLSXVDF, formatDate } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetVodafonePKRequest, GetVodafonePKResponse } from '../models/model'
import { GetPKListApi } from '../services/getPKListApi'
import '../../AccountSummary/AccountSummary.scss'
import moment from 'moment'
import IPDatePicker from '../../../../../components/IPDatePicker'
import { date } from 'yup'

interface IVodafonePKState {
  selectedCompany?: ISelectOption[]
  selectedStatus?: ISelectOption
  companyOptions: ISelectOption[]
  imei?: string
  fi?: string
  vdfurun?: string
  urunKodu?: string
  donem?: string
}

function VodafonePKDealer(props: BaseComponentWithContextProps) {
  const getInitialState = (): IVodafonePKState => {
    return {
      companyOptions: []
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IVodafonePKState>(intialState)
  const [pkData, setPkData] = useState<GetVodafonePKResponse[]>([])

  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)
  const toDateTimeLocal = date => {
    return date
      ?.toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      ?.replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [currentPage, setCurrentPage] = useState(0)

  const getPK = async () => {
    const req: GetVodafonePKRequest = {
      StartDate: startDate && formatDate(startDate),
      EndDate: endDate && formatDate(endDate),
      Imei: state.imei,
      BelgeNo: state.fi,
      VdfUrunKodu: state.vdfurun,
      UrunKodu: state.urunKodu,
      Donem: state.donem,
    }
    props.showLoading()
    const getPoDoc: GetPKListApi = new GetPKListApi({})
    getPoDoc
      .getPKList(req)
      .then(result => {
        if (result) {
          setPkData(result)
          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'PK verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
        } else {
          console.warn('PK result is empty.')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'PK verisi bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  // Tablo başlıkları
  const columnDefinitions = [
    { Header: 'IMEI', accessor: 'imei' },
    { Header: 'Belge No', accessor: 'belgeNo' },
    { Header: 'Tarih', accessor: 'tarih' },
    { Header: 'Dönem', accessor: 'donem' },
    { Header: "Malzeme No", accessor: 'malzeme' },
    { Header: 'Model', accessor: 'model' },
    { Header: 'Ürün Kodu', accessor: 'urunKodu' },
    { Header: 'Ürün Adı', accessor: 'urunAdi' },
    { Header: 'VDF Ürün Kodu', accessor: 'vdfUrun' },
    { Header: 'Kampanya', accessor: 'kampanya' },
    { Header: 'Fiyat', accessor: 'fiyat' },
    { Header: 'VDF Cari Kodu', accessor: 'vdfCari' },
    { Header: 'Şube', accessor: 'sube' },
  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableDataAndTotal = useMemo(() => {
    const tableData = pkData.map((item, index) => {
      const data = {
        imei: item.IMEI,
        belgeNo: item.BELGE_NO,
        tarih: item.TARIH ? moment(item.TARIH).format('DD.MM.YYYY') : item.TARIH,
        donem: item.DONEM,
        vdfUrun: item.VDF_URUN_KODU,
        kampanya: item.KAMPANYA,
        model: item.MODEL,
        malzeme: item.MALZEME_NO,
        urunKodu: item.URUN_KODU,
        urunAdi: item.URUN_ADI,
        fiyat: <div style={{ textAlign: 'right' }}>{item.FIYAT}</div>,
        vdfCari: item.VDF_CARI,
        sube: item.SUBE
      }
      return data
    })
    return {
      tableData,
    }
  }, [pkData])

  const excelButton = async () => {
    try {
      if (pkData) {
        const data: any[] = []
        if (pkData.length > 0) {
          pkData.map((item, index) => {
            return data.push({
              IMEI: item.IMEI,
              "BELGE NO": item.BELGE_NO,
              "TARİH": item.TARIH ? moment(item.TARIH).format('DD.MM.YYYY') : item.TARIH,
              "DÖNEM": item.DONEM,
              "VDF ÜRÜN KODU": item.VDF_URUN_KODU,
              MODEL: item.MODEL,
              "MALZEME NO": item.MALZEME_NO,
              "ÜRÜN KODU": item.URUN_KODU,
              "ÜRÜN ADI": item.URUN_ADI,
              "FİYAT": item.FIYAT,
              "VDF CARİ KODU": item.VDF_CARI,
              "ŞUBE": item.SUBE,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSXVDF(data, 'PK Bayi Hakediş', 'J')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>PK Hakediş</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>
      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='IMEI'
              name='IMEI'
              label={'IMEI'}
              value={state.imei}
              onChange={e => setState({ imei: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='FI'
              name='FI'
              label={'FI Belge No'}
              value={state.fi}
              onChange={e => setState({ fi: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='VDFUrun'
              name='VDFUrun'
              label={'VDF Ürün Kodu'}
              value={state.vdfurun}
              onChange={e => setState({ vdfurun: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='UrunKodu'
              name='UrunKodu'
              label={'Ürün Kodu'}
              value={state.urunKodu}
              onChange={e => setState({ urunKodu: e.target.value })}
              isActive
            />
          </div>
        </div>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='Donem'
              name='Donem'
              label={'Dönem'}
              value={state.donem}
              onChange={e => setState({ donem: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label={'Başlangıç Tarihi'}
              value={toDateTimeLocal(startDate)}
              onChange={e => getDate(e.target.value, 'Start')}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label={'Bitiş Tarihi'}
              value={toDateTimeLocal(endDate)}
              onChange={e => getDate(e.target.value, 'End')}
              isActive
            />
          </div>
        </div>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getPK()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
        <label style={{ color: 'red' }}><b>Dönem</b> sorgularken <b>'YYYYAA'</b> formatında ({moment(new Date()).format('YYYYMM')}) yazınız.</label>
      </form>
      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableDataAndTotal.tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={13}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}
export default componentWithContext(VodafonePKDealer)
